import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { useForm } from '../../contexts/form/form.es.js';
import { useEventListener } from '../../hooks/use-event-listener.es.js';
import { LoadingCard, PayButton } from './credit-card.styles.es.js';

function CreditCard(_ref) {
  var buttonProps = _ref.buttonProps,
      callbacks = _ref.callbacks,
      children = _ref.children,
      _ref$focus = _ref.focus,
      focus = _ref$focus === void 0 ? "cardNumber" : _ref$focus,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "rswps-card-container" : _ref$id,
      includeInputLabels = _ref.includeInputLabels,
      postalCode = _ref.postalCode,
      recalculateSize = _ref.recalculateSize,
      render = _ref.render,
      style = _ref.style,
      props = _objectWithoutProperties(_ref, ["buttonProps", "callbacks", "children", "focus", "id", "includeInputLabels", "postalCode", "recalculateSize", "render", "style"]);

  var _React$useState = React.useState(function () {
    return void 0;
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      card = _React$useState2[0],
      setCard = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      isSubmitting = _React$useState4[0],
      setIsSubmitting = _React$useState4[1];

  var buttonRef = React.useRef(null);

  var _useForm = useForm(),
      cardTokenizeResponseReceived = _useForm.cardTokenizeResponseReceived,
      payments = _useForm.payments;

  var options = React.useMemo(function () {
    var baseOptions = {
      includeInputLabels: includeInputLabels,
      postalCode: postalCode,
      style: style
    };
    return Object.keys(baseOptions).reduce(function (acc, key) {
      if (baseOptions[key] !== void 0) {
        acc[key] = baseOptions[key];
      }

      return acc;
    }, {});
  }, [includeInputLabels, postalCode, style]);

  var handlePayment = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      var result, tokenizedResult, message;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e.stopPropagation();

              if (!(buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.isLoading)) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return");

            case 3:
              if (card) {
                _context.next = 6;
                break;
              }

              console.warn("Credit Card button was clicked, but no Credit Card instance was found.");
              return _context.abrupt("return");

            case 6:
              setIsSubmitting(true);
              _context.prev = 7;
              _context.next = 10;
              return card.tokenize();

            case 10:
              result = _context.sent;

              if (!(result.status === "OK")) {
                _context.next = 16;
                break;
              }

              _context.next = 14;
              return cardTokenizeResponseReceived(result);

            case 14:
              tokenizedResult = _context.sent;
              return _context.abrupt("return", tokenizedResult);

            case 16:
              message = "Tokenization failed with status: ".concat(result.status);

              if (!(result === null || result === void 0 ? void 0 : result.errors)) {
                _context.next = 20;
                break;
              }

              message += " and errors: ".concat(JSON.stringify(result === null || result === void 0 ? void 0 : result.errors));
              throw new Error(message);

            case 20:
              console.warn(message);
              _context.next = 26;
              break;

            case 23:
              _context.prev = 23;
              _context.t0 = _context["catch"](7);
              console.error(_context.t0);

            case 26:
              _context.prev = 26;
              setIsSubmitting(false);
              return _context.finish(26);

            case 29:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[7, 23, 26, 29]]);
    }));

    return function handlePayment(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  React.useEffect(function () {
    var abortController = new AbortController();
    var signal = abortController.signal;

    var start = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(signal2) {
        var card2;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return payments === null || payments === void 0 ? void 0 : payments.card(options).then(function (res) {
                  if (!signal2.aborted) {
                    setCard(res);
                    return res;
                  }

                  return null;
                });

              case 2:
                card2 = _context2.sent;
                _context2.next = 5;
                return card2 === null || card2 === void 0 ? void 0 : card2.attach("#".concat(id));

              case 5:
                if (!focus) {
                  _context2.next = 8;
                  break;
                }

                _context2.next = 8;
                return card2 === null || card2 === void 0 ? void 0 : card2.focus(focus);

              case 8:
                if (!signal2.aborted) {
                  _context2.next = 11;
                  break;
                }

                _context2.next = 11;
                return card2 === null || card2 === void 0 ? void 0 : card2.destroy();

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function start(_x2) {
        return _ref3.apply(this, arguments);
      };
    }();

    start(signal);
    return function () {
      abortController.abort();
    };
  }, [payments, id]);
  React.useEffect(function () {
    if (card && focus) {
      card.focus(focus);
    }
  }, [card, focus]);

  if (callbacks) {
    for (var _i2 = 0, _Object$keys = Object.keys(callbacks); _i2 < _Object$keys.length; _i2++) {
      var callback = _Object$keys[_i2];
      card === null || card === void 0 ? void 0 : card.addEventListener(callback, callbacks[callback]);
    }
  }

  if (recalculateSize) {
    recalculateSize(card === null || card === void 0 ? void 0 : card.recalculateSize);
  }

  useEventListener({
    listener: handlePayment,
    type: "click",
    element: buttonRef,
    options: {
      passive: true
    }
  });

  var Button = function Button(_ref4) {
    var children2 = _ref4.children,
        isLoading = _ref4.isLoading,
        props2 = _objectWithoutProperties(_ref4, ["children", "isLoading"]);

    var id2 = "rswp-card-button";
    var disabled = isLoading || !card || isSubmitting;
    return /* @__PURE__ */React.createElement(PayButton, _objectSpread(_objectSpread({}, props2), {}, {
      "aria-disabled": disabled,
      css: props2 === null || props2 === void 0 ? void 0 : props2.css,
      disabled: disabled,
      id: id2,
      ref: buttonRef,
      type: "button"
    }), children2 !== null && children2 !== void 0 ? children2 : "Pay");
  };

  return /* @__PURE__ */React.createElement(React.Fragment, null, /* @__PURE__ */React.createElement("div", _objectSpread(_objectSpread({}, props), {}, {
    "data-testid": "rswps-card-container",
    id: id,
    style: {
      minHeight: 89
    }
  }), !card && /* @__PURE__ */React.createElement(LoadingCard, null)), typeof render === "function" ? render(Button) : /* @__PURE__ */React.createElement(Button, _objectSpread({}, buttonProps), children !== null && children !== void 0 ? children : "Pay"));
}

export { CreditCard as default };